export const ChartDateRangeTypes = {
  today: 'today',
  allTime: 'allTime',
  custom: 'custom'
}